<template>
  <div class="gallery-section" :class="[hasTitle ? 'mt-8 mt-md-10' : 'mt-6']">
    <TitleWidget v-if="hasTitle" class="mb-6">
      {{ title }}
    </TitleWidget>

    <GridWidget :cols="cols">
      <picture
        v-for="({ src, caption }, i) in items"
        :key="i"
        @click="showGallery(i)"
      >
        <img
          class="d-block"
          :src="src + '?resize=1&w=400'"
          :alt="caption"
          width="100%"
        />
      </picture>
    </GridWidget>
  </div>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import GridWidget from "../widgets/GridWidget.vue";

const _data = {
  title: "Galeria",
};

export default {
  props: {
    items: {
      type: Array, // { src }[]
      default: () => [],
    },
    cols: {
      /**
       * {
       *   xs: [String, Number],
       *   sm: [String, Number],
       *   md: [String, Number],
       *   lg: [String, Number],
       *   xl: [String, Number],
       * }
       */
      type: Object,
    },
    gap: {
      /**
       * {
       *   xs: [String, Number],
       *   sm: [String, Number],
       *   md: [String, Number],
       *   lg: [String, Number],
       *   xl: [String, Number],
       * }
       */
      type: Object,
    },
    hasTitle: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    ..._data,
  }),
  methods: {
    showGallery(index) {
      window.showGalleryWidget(this.items, index);
    },
  },
  components: {
    TitleWidget,
    GridWidget,
  },
};
</script>

<style lang="scss" scoped>
.gallery-section::v-deep {
  img {
    display: flex;
    width: 100%;
    aspect-ratio: 1.618;
    object-fit: cover;
    position: relative;
  }

  picture {
    position: relative;
  }

  picture::after {
    content: "";
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0);
    position: absolute;
    top: 0;
    left: 0;
    transition: 0.2s;
    cursor: pointer;
  }

  picture:hover::after {
    background-color: rgba(0, 0, 0, 0.2);
  }
}
</style>
